var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.planing-team-validate.hours_planning"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      "loading-secondary-footer-button": _vm.isLoading,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("suc-form-has-error", { attrs: { form: _vm.form } }),
            _c("div", { staticClass: "form-row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("time-hour-field", {
                    ref: "firstPartStartingTime",
                    attrs: {
                      form: _vm.form,
                      name: "firstPartStartingTime",
                      title: _vm.$t(
                        "pages.planing-team-validate.first_part_starting_time"
                      ),
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("time-hour-field", {
                    ref: "firstPartEndingTime",
                    attrs: {
                      form: _vm.form,
                      name: "firstPartEndingTime",
                      title: _vm.$t(
                        "pages.planing-team-validate.first_part_ending_time"
                      ),
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "form-row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("time-hour-field", {
                    ref: "secondPartStartingTime",
                    attrs: {
                      form: _vm.form,
                      name: "secondPartStartingTime",
                      title: _vm.$t(
                        "pages.planing-team-validate.second_part_starting_time"
                      ),
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("time-hour-field", {
                    ref: "secondPartEndingTime",
                    attrs: {
                      form: _vm.form,
                      name: "secondPartEndingTime",
                      title: _vm.$t(
                        "pages.planing-team-validate.second_part_ending_time"
                      ),
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }